import * as R from 'ramda'

import { getLastViewedSection } from 'components/Editor/EditorElements/elements/Button/helper'

import type { IIncompleteElement } from '../reducer'
import { getBlocksState, getContinueBlockId, getSection, getSections } from '../selectors'
import type { IProjectContext, PreviewCourseStatus, Section } from '../types'
import { updateNavigation } from './common'

export const courseStart = (state: IProjectContext) => {
  const firstSection = getSection(state, { first: true })
  if (firstSection) {
    return R.compose(
      updateNavigation({
        sectionId: firstSection.id,
        blockId: R.head(firstSection.blocksOrder),
      }),
      R.assocPath<PreviewCourseStatus, IProjectContext>(
        ['state', 'course', 'status'],
        'incomplete',
      ),
    )(state)
  }

  return state
}

export const setCourseStatus = (value: PreviewCourseStatus) => (state: IProjectContext) => {
  return R.assocPath(['state', 'course', 'status'], value, state)
}

export const setHighlightPreview = (highlight: string | null) => (state: IProjectContext) =>
  R.assocPath(['state', 'course', 'highlight'], highlight, state)

export const setIncompleteElements =
  ({ elements }: { elements: IIncompleteElement[]; sectionId: string }) =>
  (state: IProjectContext) => {
    return R.assocPath(['state', 'course', 'incompleteElements'], elements, state)
  }

export const setSidebar = (open: boolean) => (state: IProjectContext) =>
  R.assocPath(['state', 'sidebar', 'open'], open, state)

export const setSidebarChapter = (chapter: Section | null) => (state: IProjectContext) =>
  R.assocPath(['state', 'sidebar', 'chapter'], chapter, state)

export const setSidebarSearch = (search?: string) => (state: IProjectContext) =>
  R.assocPath(['state', 'sidebar', 'search'], search, state)

export const courseContinue = (state: IProjectContext) => {
  const sections = getSections(state)
  const blocksState = getBlocksState(state)
  const lastViewedSection = getLastViewedSection(sections, blocksState)
  const continueBlock = getContinueBlockId(state, lastViewedSection?.id)
  if (lastViewedSection && continueBlock) {
    return updateNavigation({
      sectionId: lastViewedSection.id,
      blockId: continueBlock,
    })(state)
  }

  return state
}

export const setIncompleteSections = (sections: string[]) => (state: IProjectContext) =>
  R.assocPath(['state', 'course', 'notCompletedSections'], sections, state)

export const showIncompleteElementList = (state: IProjectContext) => {
  state.state.course.incompletePopoverVisible = true
  state.state.course.incompleteElementShakeKey =
    (state.state.course?.incompleteElementShakeKey || 0) + 1
  return state
}

export const hideIncompleteElementList = (state: IProjectContext) => {
  state.state.course.incompletePopoverVisible = false
  return state
}

export const showNotCompletedSections = (state: IProjectContext) => {
  state.state.course.viewNotCompletedSections = true
  state.state.course.incompleteElementShakeKey =
    (state.state.course?.incompleteElementShakeKey || 0) + 1
  return state
}

export const hideNotCompletedSections = (state: IProjectContext) => {
  state.state.course.viewNotCompletedSections = false
  return state
}
